import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import Modal from '../../../shared/ui/Modal';
import usersActions from '../../store/users/action-creators/index';
import usersActionCreators from '../../store/users/action-creators/index';
import tagsSelectors from '../../store/tags/selectors';
import usersSelectors from '../../store/users/selectors';
import AddActionButton from '../common/AddActionButton';
import './UserIndex.scss';
import {oitChangeDivisionConfig, userAddConfig} from "../../../shared/components/form/UserFormConfig";
import optionsActionCreators from "../../../subscriber-app/store/options/action-creators";
import CustomForm from "../../../shared/components/form/CustomForm";
import UserTable from './UserTable';
import UserTagsManage from './UserTagsManage';
import {resendPassword, resetPassword, showTempPass} from "../../../shared/services/auth";
import notificationsActionCreators from "../../store/notifications/action-creators";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import departmentSettingsActionsCreators from '../../store/department-settings/action-creators/index';

class UserIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      isManagingTags: false,
      showTempPass: null,
      isCreatingUser: false,
      showDivisionModal: false,
      isChangingDivision: false,
      selectedUser: null
    };
  }

  componentDidMount() {
    if(!this.props.rolesOptions) {
      this.props.fetchOptions('roles');
    }
    if(!this.props.settings) {
      this.props.loadDepartmentSettings();
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  onShowUserDetails(userGuid) {
    this.props.setSelectedUser(userGuid);
    if(this.props.userContext.hasScope('admin')) {
      this.props.history.push(`/admin/users/${userGuid}`);
    } else {
      this.props.history.push(`/users/${userGuid}`);
    }
  }

  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return !this.props.users || !this.props.settings || !this.props.rolesOptions;
  }

  get selectedUserFullName() {
    return this.props.selectedUser ? this.props.selectedUser.getFullName() : '';
  }

  get subDepartments () {
    let departments = [];
    //if (this.props.userContext) {
    //  departments.push({
    //     guid: this.props.userContext.masterDepartment,
    //     name: 'Main department'
    //  });
    //}

    departments.push(...this.props.subDepartments);

    return departments;
  }

  get rolesOptionsTranslated() {
    if (this.props.rolesOptions && this.props.settings) {
      return this.props.rolesOptions.reduce((acc, role) => {
        const roleName = this.props.settings.rolesSettings && this.props.settings.rolesSettings[role.scope];
        return [
          ...acc,
          {
            ...role,
            label: roleName ? roleName : role.name
          }
        ];

      }, []);
    }
  }

  // ----------------------
  // State Setters
  // ----------------------

  closeManageTags() {
    this.setState({ isManagingTags: false });
    this.props.setSelectedUser(null);
  }

  openManageTags(userGuid) {
    this.setState({ isManagingTags: true });
    this.props.setSelectedUser(userGuid);
  }

  resetPassword(email) {
    resetPassword(email)
      .then(() => {
        this.props.showMsg(`Password is reset`)
      })
      .catch(() => {
        this.props.showError(`Temporary password not expired`)
      })
  }

  resendPassword(guid) {
    resendPassword(guid)
      .then(() => {
        this.props.showMsg(`Temporary password was sent`)
      })
      .catch(() => {
        this.props.showError(`Temporary password not expired`)
      })
  }

  onShowTempPass(user) {
    showTempPass(user.guid)
      .then(pass => {
        this.setState({
          showTempPass: pass,
        });
        this.props.setSelectedUser(user.guid);
      })
  }

  onChangeDivision(user) {
    this.setState({
      showDivisionModal: true,
      selectedUser: user
    });
  }

  closeChangeDivision() {
    this.setState({
      showDivisionModal: false
    });
  }

  closeShowTempPass() {
    this.setState({
      showTempPass: null,
    });
    this.props.setSelectedUser(null);
  }

  saveUser(formData) {
    this.setState({
      isCreatingUser: true
    });

    let phones = [
      {
        countryCode: '1',
        isDefault: true,
        label: 'default',
        phoneNumber: formData.phones.replace('-', '').replace('(', '').replace(')', '').replace(' ', '')
      },
    ];

    formData = {
      ...formData,
      phones: phones
    }

    this.props.createUser(formData).
      then(() => {
        this.setState({
          isCreatingUser: false
        })
      })
      .catch(() => {
        this.setState({
          isCreatingUser: false
        })
      });
  }

  changeDivision(formData) {
    this.setState({
      isChangingDivision: true
    })

    let data = {
      oit_guid: this.state.selectedUser.guid,
      department_guid: formData.divisionGuid
    }

    this.props.changeOitDivision(data).
      then(() => {
        this.setState({
          isChangingDivision: false,
          showDivisionModal: false
        })
      })
      .catch(() => {
        this.setState({
          isChangingDivision: false
        })
      });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        <Fragment>
          {!this.isLoading && (
            <Fragment>
              <div className="app-content-header">
                <h4 className="title">Users </h4>
                <AddActionButton label="User" onAdd={this.props.addUser} />
              </div>
              <div className="app-content">
                {!this.props.users ? (
                  <div className="alert alert-primary" role="alert">
                    No Users found
                  </div>
                ) : (
                  <UserTable
                    onManageTags={userGuid => this.openManageTags(userGuid)}
                    onResetPassword={email => this.resetPassword(email)}
                    onResendPassword={email => this.resendPassword(email)}
                    onShowDetails={userGuid =>
                      this.onShowUserDetails(userGuid)
                    }
                    onShowPassword={user => this.onShowTempPass(user)}
                    onChangeDivision={user => this.onChangeDivision(user)}
                    onEnableDisableUser={(user, active) => this.props.enableDisableUser(user.guid, active)}
                    onEnableDisableLoginAccess={(user, active) => this.props.enableDisableLoginAccess(user.guid, active)}
                    users={this.props.users}
                  />
                )}
              </div>
            </Fragment>
          )}
          <Modal
            isOpen={this.props.isAddingUser}
            title="Create user"
            onClose={() => this.props.closeAddUser()}
          >
            <div className="create-user-modal">
              <CustomForm
                config={userAddConfig}
                isLoading={this.state.isCreatingUser}
                rolesOptions={this.rolesOptionsTranslated}
                onSubmit={form => this.saveUser(form)} />
              </div>
          </Modal>
          <Modal
            isOpen={this.state.isManagingTags}
            title={`Manage tags for ${this.selectedUserFullName}`}
            onClose={() => this.closeManageTags()}
          >
            <UserTagsManage
              tags={this.props.userTags}
              user={this.props.selectedUser}
            />
          </Modal>
          <Modal
            isOpen={this.state.showTempPass}
            title={this.state.showTempPass ? this.selectedUserFullName : ''}
            onClose={() => this.closeShowTempPass()}
          >
            <p style={{padding: '20px'}}>
              Temp pass: {this.state.showTempPass ? this.state.showTempPass.password : ''}
            </p>
          </Modal>

          <Modal
            isOpen={this.state.showDivisionModal}
            title={`Change ${this.props.oitShortLabel} division`}
            onClose={() => this.closeChangeDivision()}
          >
            {this.state.showDivisionModal && <div className="crfrrfeate-user-modal">
              <CustomForm
                config={oitChangeDivisionConfig}
                initialValues={{divisionGuid: this.props.userContext.departmentGuid}}
                isLoading={this.state.isChangingDivision}
                divisionsOptions={this.subDepartments.map(d => ({...d, label: d.name}))}
                onSubmit={form => this.changeDivision(form)}/>
            </div>}
          </Modal>
        </Fragment>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    isAddingUser: state.users.isAddingUser,
    selectedUser: usersSelectors.selectedUser(state),
    users: state.users.list,
    isLoading: state.users.isLoading,
    userTags: tagsSelectors.userTags(state),
    rolesOptions: state.options.roles,
    trainingProgramsOptions: state.options.trainingPrograms,
    subDepartments: state.subDepartments.list,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    settings: state.departmentSettings.settings
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addUser: () => dispatch(usersActions.addUser()),
    createUser: formData => dispatch(usersActionCreators.createUser(formData)),
    changeOitDivision: formData => dispatch(usersActionCreators.changeOitDivision(formData)),
    closeAddUser: () => dispatch(usersActions.closeAddUser()),
    enableDisableUser: (userGuid, active) => dispatch(usersActions.enableDisableUser(userGuid, active)),
    enableDisableLoginAccess: (userGuid, active) => dispatch(usersActions.enableDisableLoginAccess(userGuid, active)),
    setSelectedUser: (userGuid) => {
      return dispatch(usersActions.setSelectedUser(userGuid));
    },
    showMsg: (message) => {
      return dispatch(notificationsActionCreators.addSavedSuccessfully(message))
    },
    showError: (message) => {
      return dispatch(notificationsActionCreators.addError(message))
    },
    fetchOptions: (apiKey) => {
      return dispatch(optionsActionCreators.fetchOptions(apiKey))
    },
    loadDepartmentSettings: () => {
      dispatch(departmentSettingsActionsCreators.loadDepartmentSettings());
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserIndex));
